import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { ServicesProvider } from '../ServicesProvider.js';
import { payableServicesProviderDataSchema } from './ServicesProviderPayableData.js';

// Base class for ServicesProviders that need to be payable
class PayableServicesProvider extends ServicesProvider {
    constructor(data) {
        super(data);
        this.validatePayableData(data);
        this.taxNumber = data.taxNumber;
        this.payment = data.payment;
        this.legalName = data.legalName;
        this.legalAddress = data.legalAddress;
    }
    validatePayableData(data) {
        const result = payableServicesProviderDataSchema.safeParse(data);
        if (!result.success) {
            createLog('PayableServicesProvider.validation', `PayableServicesProvider data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
    /**
     * Gets the legal address of this ServicesProvider.
     */
    getAddress() {
        return this.legalAddress ?? null;
    }
}
// Register PayableServicesProvider with ServicesProvider
ServicesProvider.registerPayableSubclass(PayableServicesProvider);

export { PayableServicesProvider };
//# sourceMappingURL=ServicesProviderPayable.js.map
